import { useIntl } from 'react-intl';

export function PromptHeader() {
  const { formatMessage } = useIntl();
  return (
    <h2 id="greeting-msg" className="greeting-msg mb-12px">
      {formatMessage({ id: 'smartQuote.workspace.promptConfigurator.promptInput.header' })}
    </h2>
  );
}
